import axios from "axios"
// const link = 'http://localhost:8080'
// const linkFront = 'http://localhost:8081'

// pred-prod
// const link = 'https://kris-bang.alwaysdata.net/api-inscription-online-tkd-cergy-elite'
// const linkFront = 'https://mr-ambang.com/inscription-online/pre-prod-tkd-elite-cergy'

//prod-new
const link = 'https://inscription-online.alwaysdata.net/api-inscription-online-tkd-elite-cergy'
const linkFront = 'https://taekwondoelite.inscription-online.fr'


const URL = link + '/Api'

const instance = axios.create({
    baseURL: URL,
  });  

  if(sessionStorage.getItem('token') && sessionStorage.getItem('token')!=""){
    instance.defaults.headers.common['Authorization'] = `${sessionStorage.getItem('token')}`;
  }

  instance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config;
    if (error.config.url != "/user/refreshToken" && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      if (sessionStorage.getItem('refreshToken') && sessionStorage.getItem('refreshToken')!="") {
        instance.defaults.headers.common['Authorization'] = `${sessionStorage.getItem('refreshToken')}`;
        console.log('refreshToken');
        await instance.post('/user/refreshToken').then((response) => {
          // TODO: mettre à jour l'accessToken dans le sessionStorage
          console.log('refreshToken',response.data);
          sessionStorage.setItem("refreshToken", response.data.accessToken)
          originalRequest.headers['Authorization'] = `${response.data.accessToken}`;
          instance.defaults.headers.common['Authorization'] = `${response.data.accessToken}`;
        }).catch((err) => {
          console.log(err.response.status);
          sessionStorage.setItem("refreshToken", null);
        });
        return instance(originalRequest);
      }
    }
    return Promise.reject(error);
  });

  export default{
    instance:instance,
    api_url:link,
    front_url:linkFront
}


